import Placeholder from '@atlaskit/react-ufo/placeholder';
import { logoBase64 } from '@dev-agents/boysenberry-logo';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';

import { LayoutBoysenberry } from '../layout-boysenberry';
import { useDarkMode } from '../use-dark-mode';
import { useFavicon } from '../use-favicon';

export const BoysenberryAppContext = ({
	children,
	isFullscreen,
}: {
	children: React.ReactNode;
	isFullscreen?: boolean;
}) => {
	useDarkMode();
	useFavicon(logoBase64);
	return (
		<ErrorBoundary>
			<LayoutBoysenberry isFullscreen={isFullscreen}>
				<Placeholder name="boysenberry-app">{children}</Placeholder>
			</LayoutBoysenberry>
		</ErrorBoundary>
	);
};
